import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getListReward } from '../../../controller/api/__classic__/reward'
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    from: new Date(),
    to: new Date(),
    phone: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  filterPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: Boolean(action.payload)
      }
    default:
      return {
        ...state
      }
  }
}

export default ({ region }) => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getAllFunc = useCallback(async () => {

    dispatch({ type: 'SET_LOADING', payload: true });

    let phone = state.filter.phone

    if (phone.indexOf('MB') < 0) {
      phone = phone.replace('0', '+84')
    }

    try {
      const response = await getListReward(cookies.lottmekong, {
        from: state.filter.from,
        to: state.filter.to,
        phone: phone,
        region: region
      }, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total)
          }
        })
      }
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.page, state.filter.phone, region])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page, region])

  useEffect(() => {
    document.title = region === 'MN' ? 'Trúng thưởng Miền Nam' : 'Trúng thưởng Miền Trung'
  }, [region]);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm region={region} />

      <br />

      <Summary />

      <br />

      <Table />
    </Context.Provider>
  );
};
